import { Link, LinkProps } from 'react-router';
import * as React from 'react';
import { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightToBracket } from '@fortawesome/free-solid-svg-icons/faRightToBracket';

interface Props extends LinkProps {
  idx?: number;
  internalIcon?: boolean;
}

const defaultProps: Partial<Props> = {
  internalIcon: false,
};

export const InternalLink = (props: Props): ReactNode => {
  const {internalIcon, ...settings} = {...defaultProps, ...props};
  return (
    <Link
      key={props.idx}
      className={`no-underline flex align-items-center text-primary-800 ${props.className || ''}`}
      {...settings}
    >
      <span className={'inline-flex gap-2'}>
        {props.children}
        {(internalIcon) && <span className={'opacity-50'}><FontAwesomeIcon icon={faRightToBracket}/></span>}
      </span>
    </Link>
  );
};
